import { Article } from '../../../interface';
import getFlagValue, { FLAG_ENUM } from '../../utils/getFlagValue';
import { addQueueGlobalCount, resetQueueGlobalCount } from 'ui/store/emarsys/action';
import { store } from 'ui/store';
import { IBreadcrumbs } from 'ui/components/molecules/Breadcrumbs';
import { dateFormatter } from 'ui/helpers/utils';

export const promoButtonClickOption = {
  mintaPenawaran: 'minta penawaran',
  lihatSemuaPromo: 'lihat semua promo',
  whatsapp: 'social_share_button_whatsapp',
  facebook: 'social_share_button_facebook',
  x: 'social_share_button_x',
  tiktok: 'social_share_button_tiktok',
  shareCopylink: 'social_share_button_copylink',
};

const eventClickNewsDetail = (
  news: Article,
  breadcrumbItems: IBreadcrumbs[],
  buttonName: string,
  sectionName: string
) => {
  const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
  const isNewsActive = getFlagValue(FLAG_ENUM.EMARSYS_NEWS_DETAIL);
  if (!isFlagActive || !isNewsActive) return;
  const state = store.getState();
  const { userData } = state.auth || {
    userData: null,
  };
  if (userData?.customerNo) {
    ScarabQueue.push(['setCustomerId', userData?.customerNo]);
  }

  const valuePageView: Record<string, string | number | boolean> = {
    page_name: 'berita & tips',
    page_title: news?.titlePage || '',
    page_url: window.location.href,
    menu_cat_lvl1: breadcrumbItems[1]?.name?.toUpperCase() || '',
    menu_cat_lvl2: breadcrumbItems[2]?.name?.toUpperCase() || '',
    release_date: dateFormatter(news?.publishedDate),
    section_name: sectionName,
    button_name: buttonName,
  };

  ScarabQueue.push(['tag', 'click_button', valuePageView]);

  if (buttonName.includes('lihat semua')) {
    ScarabQueue.push(['go']);
    store.dispatch(resetQueueGlobalCount());
  } else {
    store.dispatch(addQueueGlobalCount());
  }
};

export default eventClickNewsDetail;
